import { ulid } from "ulid";

/** ULID ids everywhere (SPEC §3). */
export const newId = () => ulid();

export const nowIso = () => new Date().toISOString();
export const todayIso = (tz = "America/Chicago", d = new Date()) =>
  new Intl.DateTimeFormat("en-CA", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
